







































































































































































import TeacherInfoPage from '../../teacher/info/TeacherInfoPage.vue';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { TeacherService } from '../../biz/remote/TeacherService';
import { DaTeacherService } from '../../biz/remote/DaTeacherService';
import { MessageDialog } from '../../utils/MessageDialog';
import FileInput from '../../teacher/info/FileInput.vue';
import { subjectsOptions } from '../../../src_server/entity/master/subjectsData';
import { schoolYearsOptions } from '../../../src_server/entity/master/schoolYearsData';
import { FileUpload } from '../../biz/FileUpload';
import SimpleCheckBox from '../../components/inputs/SimpleCheckBox.vue';
import Editor from './Editor.vue';
import { Session } from '../../utils/Session';
import ClassBasicStrengthLevelPanel from './ClassBasicStrengthLevelPanel.vue';
import { ClassBasicStrenghtLevel } from '../../../src_server/entity/generated/ClassBasicStrenghtLevel';
import CourseOperatorSection from './CourseOperatorSection.vue';
import { DaCourseOperator } from '../../../src_server/entity/generated/DaCourseOperator';
@Component({
  components: {
    TeacherInfoPage,
    CommonDialog,
    FileInput,
    SimpleCheckBox,
    Editor,
    ClassBasicStrengthLevelPanel,
    CourseOperatorSection,
  },
})
export default class TeacherInfoMaintenance extends Vue {
  private info: TeacherInfoInputDTO = new TeacherInfoInputDTO();
  private currentPage = 0;
  private type: 'add' | 'detail' = 'detail';
  private classBasicStrengthLevel: ClassBasicStrenghtLevel[] = [];

  private get selectedCourse() {
    return this.classBasicStrengthLevel.map((c) => c.strength_item).join(',');
  }

  private set selectedCourse(value: string) {
    this.classBasicStrengthLevel = value.split(',').map((v) => {
      const entity = new ClassBasicStrenghtLevel();
      entity.user_id = this.info.teacher.user_id;
      entity.strength_item = v;
      return entity;
    });
  }

  get model() {
    return this.info.teacher;
  }

  get subjects() {
    return subjectsOptions;
  }

  get schoolYears() {
    return schoolYearsOptions.filter((i) => {
      return i.title !== '特に高校受験に向けた中学生の受験生' && i.title !== '特に大学受験に向けた高校生の受験生';
    });
  }

  get contents() {
    if (!this.info.da_teacher?.contents) {
      return '';
    }
    return this.info.da_teacher?.contents;
  }

  set contents(value: string) {
    this.info.da_teacher.contents = value;
  }

  // private is_time_flex = 0;

  set is_time_flex(value: string) {
    // console.log(value);
    this.info.da_teacher.is_time_flex = value == '1' ? true : false;
  }

  get is_time_flex() {
    return this.info.da_teacher?.is_time_flex ? '1' : '0';
  }

  set is_show_reservation_page(value: string) {
    // console.log(value);
    this.info.da_teacher.is_show_reservation_page = value == '1' ? true : false;
  }

  get is_show_reservation_page() {
    return this.info.da_teacher?.is_show_reservation_page ? '1' : '0';
  }

  get isFlexTimeOptions(): { title: string; value: string }[] {
    return [
      { title: '柔軟に設定可能', value: '1' },
      { title: 'フルタイム参加必須', value: '0' },
    ];
  }

  set is_shown_admin_page(value: string) {
    // console.log(value);
    this.info.da_teacher.is_shown_admin_page = value == '1' ? true : false;
  }

  get is_shown_admin_page() {
    return this.info.da_teacher?.is_shown_admin_page ? '1' : '0';
  }

  get isShowReservationOptions(): { title: string; value: string }[] {
    return [
      { title: '表示する', value: '1' },
      { title: '表示しない', value: '0' },
    ];
  }

  get isShowAdminOptions(): { title: string; value: string }[] {
    return [
      { title: '表示する', value: '1' },
      { title: '表示しない', value: '0' },
    ];
  }

  @Prop({ default: false })
  private forDisplay!: boolean;

  // async uplaodFile() {
  //   console.log('onUploadFile');
  // }

  // onIconimageAdd(image: File) {
  //   this.info.teacher = image;
  // }

  created() {
    this.info.files.icon_image_file = new File([], '');
  }

  /**
   * 詳細ボタンのイベントハンドラ
   */
  public async show(row: TeacherInfoInputDTO, type: 'add' | 'detail') {
    this.type = type;
    this.info = row;
    const dialog = this.$refs['teacher_detail_dialog'] as CommonDialog;

    // クラスの基礎力レベル
    const biz = new DaTeacherService();
    const response = await biz.getCourses(this.info.teacher.user_id!);
    this.classBasicStrengthLevel = response.data;
    dialog.show();
  }

  hide() {
    const dialog = this.$refs['teacher_detail_dialog'] as CommonDialog;
    dialog.hide();
  }

  async add() {
    const isOK = await MessageDialog.confirm(`${this.info.teacher.nickname}さんのデータを追加します。よろしいですか？`);
    if (isOK) {
      const biz = new DaTeacherService();
      const result = await biz.maintenanceAdd(this.info, Session.getSessionBuildingId());

      const resultInfo = result.data;
      const user_id = resultInfo.userAuth.user_id;
      if (!user_id) {
        await MessageDialog.systemError('ユーザーID', 'メンテナンス登録時', user_id);
        return;
      }

      // 選択コースの登録
      await biz.deleteInsertCourses(user_id, this.classBasicStrengthLevel);

      // アイコン写真のアップロード
      if (this.info.files.icon_image_file) {
        const biz = new FileUpload();
        // console.log('before upload user_id', user_id);
        const fileUpResult = await biz.fileUpload(user_id, 'teacher_icon', this.info.files.icon_image_file);
        resultInfo.teacher.img_path = fileUpResult;
      }

      this.$emit('added', resultInfo);
      this.hide();
    }
  }

  async update() {
    // console.log(this.info);

    if (this.info.da_teacher.limit_count === 0) {
      await MessageDialog.info(`定員が0なので全ての予約が承認依頼になります。`);
    }
    if (this.info.da_teacher.limit_days_befor === 0) {
      await MessageDialog.info(`自動確定の申込期限が0なので無期限です。`);
    } else if (!this.info.da_teacher.limit_days_befor || this.info.da_teacher.limit_days_befor < 0) {
      await MessageDialog.alert(`自動確定の申込期限はプラスの数字で入力してください。0に設定すると無期限になります。`);
      return;
    }

    const user_id = this.info.userAuth.user_id;
    if (!user_id) {
      await MessageDialog.systemError('ユーザーID', 'メンテナンス更新時', user_id);
      return;
    }
    const biz = new DaTeacherService();
    const updateResult = await biz.maintenanceUpdate(user_id, this.info);
    const updateResultInfo = updateResult.data;

    // 選択コースの登録
    await biz.deleteInsertCourses(user_id, this.classBasicStrengthLevel);

    // アイコン写真のアップロード
    if (this.info.files.icon_image_file) {
      const biz = new FileUpload();
      console.log('before upload user_id', user_id);
      const fileUpResult = await biz.fileUpload(user_id, 'teacher_icon', this.info.files.icon_image_file);
      updateResultInfo.teacher.img_path = fileUpResult;
    }

    this.hide();
    this.$emit('updated', updateResultInfo);
  }

  async deleteComplete() {
    if (!this.info.userAuth.user_id) {
      await MessageDialog.systemError('ユーザーID', 'メンテナンス更新時', this.info.userAuth.user_id);
      return;
    }
    const isOK = await MessageDialog.confirm(`${this.info.teacher.nickname}/${this.info.teacher.full_name}さんのデータを完全に削除します。この処理は戻せません。よろしいですか？`);
    if (isOK) {
      const biz = new TeacherService();
      await biz.completeDelete(this.info.userAuth.user_id);
      this.$emit('deleted', this.info.userAuth.user_id);
      this.hide();
    }
  }

  courseOperatorSelected(courseOperators: DaCourseOperator[]) {
    console.log('courseOperatorSelected', courseOperators);
    this.info.da_course_operator = courseOperators;
  }
}
